// Painel Super Master > Protocolos (pedido 2026-09-07) — catálogo global
// de protocolos de rastreador disponíveis pra empresas escolherem no
// cadastro de veículo e no catálogo de Comandos GT06. GET é público (sem
// sessão nenhuma — ver comentário em tracker-protocols.controller.ts no
// backend): lido tanto pela tela do Super Master quanto por qualquer
// empresa, por isso usa gpsDriveGet e não o cliente da plataforma.
// Editar/excluir são exclusivos do Super Master. Criar tem duas portas:
// `create` (Super Master, catálogo oficial) e `createQuick` (pedido
// 2026-09-16, opção "Outro" no cadastro de veículo — qualquer usuário
// autenticado comum, por isso usa gpsDrivePost e não platformPost).
import { gpsDriveGet, gpsDrivePost } from "@/lib/api/gpsdrive-client";
import { platformDelete, platformPatch, platformPost } from "@/lib/api/gpsdrive-platform-client";

export interface TrackerProtocolEntry {
  id: string;
  value: string;
  label: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateTrackerProtocolInput {
  value: string;
  label: string;
}

export const gpsDriveTrackerProtocolsService = {
  list: () => gpsDriveGet<TrackerProtocolEntry[]>("/api/v1/tracker-protocols"),
  create: (input: CreateTrackerProtocolInput) =>
    platformPost<TrackerProtocolEntry>("/api/v1/tracker-protocols", input),
  createQuick: (label: string) =>
    gpsDrivePost<TrackerProtocolEntry>("/api/v1/tracker-protocols/quick", { label }),
  updateLabel: (id: string, label: string) =>
    platformPatch<TrackerProtocolEntry>(`/api/v1/tracker-protocols/${id}`, { label }),
  remove: (id: string) => platformDelete(`/api/v1/tracker-protocols/${id}`),
};
